import { render, staticRenderFns } from "./Bestellungen.vue?vue&type=template&id=0c373586"
import script from "./Bestellungen.vue?vue&type=script&lang=ts"
export * from "./Bestellungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports